import React from 'react'

export default function InviteAcceptPage() {
    return (
        <div>InviteAcceptPage</div>
    )
}
